import type { ThemeConfig } from 'antd';

export const AOTV_GREEN = '#428e3e';
// Local brand assets — drop the real files into public/brand/ per the
// README. We keep the AWS CDN URLs as a fallback so a missing local
// asset doesn't break the login screen.
export const AOTV_LOGO = '/brand/logo-colour.png';
export const AOTV_LOGO_FALLBACK =
  'https://d2y18d7bbdaphy.cloudfront.net/img/aotv-logo.png';
export const AOTV_LOGO_ICON = '/brand/favicon.png';
export const AOTV_LOGO_ICON_FALLBACK =
  'https://d2y18d7bbdaphy.cloudfront.net/img/aotv-icon-logo.png';

export const theme: ThemeConfig = {
  token: {
    colorPrimary: AOTV_GREEN,
    colorLink: AOTV_GREEN,
    colorBgBase: '#ffffff',
    colorBgLayout: '#ffffff',
    colorBgContainer: '#ffffff',
    borderRadius: 6,
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      bodyBg: '#ffffff',
      siderBg: '#ffffff',
    },
    Menu: {
      itemBg: 'transparent',
    },
    Card: {
      colorBgContainer: '#ffffff',
    },
    Table: {
      rowSelectedBg: '#fbfbfb',
      rowSelectedHoverBg: '#f5f5f5',
    },
  },
};
